import PropTypes from 'prop-types';
import React, { PureComponent } from 'react';
import ModeComment from '@material-ui/icons/ModeComment';

import CreateGroup from './CreateConversation.container';
import Scrollbar from '../../common/ScrollBar';
import ConversationFilter from './ConversationFilter.container';

import {
  Button,
  ButtonContainer,
  Container,
  ConversationList,
  Loader,
  InboxButton,
  InboxButtonCount,
  IconButtonInner,
  IconButtonText,
  ArrowIcon,
  styles,
} from './Inbox.styled';
import InboxItem from './InboxItem.container';

const IS_DM_COLLAPSED = 'aula-is-dm-collapsed';

const debounce = (delay, fn) => {
  let timeout;
  return (...args) =>
    new Promise((resolve, reject) => {
      const later = () => {
        timeout = null;
        try {
          resolve(fn(...args));
        } catch (error) {
          reject(error);
        }
      };
      clearTimeout(timeout);
      setTimeout(later, delay);
    });
};

class InboxMenu extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      filteredConversationIds: null,
      filterValue: '',
      isInboxCollapsed: localStorage.getItem(IS_DM_COLLAPSED) === 'true',
    };

    this.conversationFilter = null;

    const { filterConversations } = this.props;
    this.filterConversations = debounce(200, filterConversations);
    this.onFilterChange = this.onFilterChange.bind(this);
    this.setConversationFilter = this.setConversationFilter.bind(this);
    this.changeGroup = this.changeGroup.bind(this);
    this.handleCollapse = this.handleCollapse.bind(this);
    this.hanldeExpand = this.hanldeExpand.bind(this);
  }

  async onFilterChange(filterValue) {
    this.setState({ filterValue });
    if (!filterValue) return;

    const filteredConversationIds = await this.filterConversations(filterValue);
    this.setState({ filteredConversationIds });
  }

  setConversationFilter(reference) {
    this.conversationFilter = reference;
  }

  changeGroup() {
    if (this.conversationFilter) {
      this.conversationFilter.reset();
    }
    const { changeGroup } = this.props;
    changeGroup();
  }

  handleCollapse() {
    this.setState({ isInboxCollapsed: true });
    localStorage.setItem(IS_DM_COLLAPSED, 'true');
  }

  hanldeExpand() {
    this.setState({ isInboxCollapsed: false });
    localStorage.setItem(IS_DM_COLLAPSED, 'false');
  }

  render() {
    const {
      filteredConversationIds,
      filterValue,
      isInboxCollapsed,
    } = this.state;

    const {
      conversationsIds,
      fetchingConversations,
      openCreateGroup,
      getMenuProps,
      getItemProps,
      highlightedIndex,
      getInputProps,
      setItemCount,
      totalUnreadConversations,
    } = this.props;

    const visibleConversationIds =
      filterValue && filteredConversationIds !== null
        ? filteredConversationIds
        : conversationsIds;

    setItemCount(visibleConversationIds.length);

    const { role, ...menuProps } = getMenuProps();
    const unreadBadgeMessage =
      totalUnreadConversations > 99 ? ':)' : `${totalUnreadConversations}`;

    return (
      <>
        <Container
          className={isInboxCollapsed ? styles.shrinked : styles.expanded}
        >
          <ButtonContainer>
            <Button
              type="primary"
              onClick={openCreateGroup}
              id="new-message"
              iconLeft={ModeComment}
              data-testid="new-message-button"
              aria-label="Create new conversation"
            >
              <span>New message</span>
            </Button>
          </ButtonContainer>
          <ConversationList aria-live="polite" {...menuProps}>
            <Scrollbar
              viewProps={{ role: 'listbox', 'data-testid': 'messages-list' }}
              autoHide
            >
              {visibleConversationIds.map((conversationId, index) => (
                <InboxItem
                  key={conversationId}
                  changeGroup={this.changeGroup}
                  conversationId={conversationId}
                  highlighted={highlightedIndex === index}
                  getItemProps={getItemProps}
                  index={index}
                />
              ))}
              {fetchingConversations && !conversationsIds.length && <Loader />}
            </Scrollbar>
          </ConversationList>

          <ConversationFilter
            ref={this.setConversationFilter}
            onChange={this.onFilterChange}
            getInputProps={getInputProps}
            handleCollapse={this.handleCollapse}
          />
          <CreateGroup />
        </Container>
        <InboxButton
          className={
            isInboxCollapsed
              ? styles.inboxButtonShown
              : styles.inboxButtonHidden
          }
          onClick={this.hanldeExpand}
        >
          <IconButtonInner>
            <IconButtonText>Messages</IconButtonText>
            {totalUnreadConversations && (
              <InboxButtonCount>{unreadBadgeMessage}</InboxButtonCount>
            )}
          </IconButtonInner>
          <ArrowIcon />
        </InboxButton>
      </>
    );
  }
}

InboxMenu.propTypes = {
  conversationsIds: PropTypes.arrayOf(PropTypes.string).isRequired,
  filterConversations: PropTypes.func.isRequired,
  openConversation: PropTypes.func.isRequired,
  fetchingConversations: PropTypes.bool.isRequired,
  openCreateGroup: PropTypes.func.isRequired,
  getMenuProps: PropTypes.func.isRequired,
  getItemProps: PropTypes.func.isRequired,
  getInputProps: PropTypes.func.isRequired,
  setItemCount: PropTypes.func.isRequired,
  highlightedIndex: PropTypes.number,
  changeGroup: PropTypes.func.isRequired,
  totalUnreadConversations: PropTypes.number,
};

InboxMenu.defaultProps = {
  highlightedIndex: null,
  totalUnreadConversations: 0,
};

export default InboxMenu;
